import React from "react";
import { Grid, Typography } from "@material-ui/core";

import PaymentDetailTable from "../Tables/PaymentDetailTable";
import Heading from "../../../../StyledComponents/Heading/Heading";

const PaymentImport = ({
  formState,
  formState1,
  setImportPaymentDetail,
  setFormState,
  multipleData,
  vendor,
  inv_amount,
  invoiceData,
  edit,
  disable,
  newFormState,
}) => {


  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} mt={2} style={{ width: "0" }}>
        <Heading title="Payment Details" />
        <PaymentDetailTable
          formState={formState}
          formState1={formState1}
          setImportPaymentDetail={setImportPaymentDetail}
          setFormState={setFormState}
          invoiceData={invoiceData}
          multipleData={multipleData}
          vendor={vendor}
          inv_amount={inv_amount}
          edit={edit}
          disable={disable}
        />
      </Grid>
    </Grid>
  );
};

export default PaymentImport;

const a = [
  {
    ReferenceId: "536",
    ReferenceKey: "PostingKey",
    ReferenceCode: "21",
    ReferenceText: "Credit Memo",
    ReferenceProp1: "V",
    ReferenceProp2: "D",
    ReferenceProp3: "",
    ReferenceProp4:
      "TaxAmount,TaxCode,BaselineDate,PmtTerms,PmtMethod,PmtMethodSupp,IndPayee",
    IsActive: "True",
  },
  {
    ReferenceId: "537",
    ReferenceKey: "PostingKey",
    ReferenceCode: "29",
    ReferenceText: "Special G/L debit",
    ReferenceProp1: "V",
    ReferenceProp2: "D",
    ReferenceProp3: "",
    ReferenceProp4:
      "TaxAmount,TaxCode,SGLInd,DueOn,PmtMethod,PmtMethodSupp,ProfitCenter,IndPayee",
    IsActive: "True",
  },
  {
    ReferenceId: "538",
    ReferenceKey: "PostingKey",
    ReferenceCode: "31",
    ReferenceText: "Invoice",
    ReferenceProp1: "V",
    ReferenceProp2: "C",
    ReferenceProp3: "",
    ReferenceProp4:
      "TaxAmount,TaxCode,BaselineDate,PmtTerms,PmtMethod,PmtMethodSupp,IndPayee",
    IsActive: "True",
  },
  {
    ReferenceId: "539",
    ReferenceKey: "PostingKey",
    ReferenceCode: "40",
    ReferenceText: "Debit entry",
    ReferenceProp1: "G",
    ReferenceProp2: "D",
    ReferenceProp3: "",
    ReferenceProp4: "TaxCode,WBSElement,CostCenter,ProfitCenter",
    IsActive: "True",
  },
  {
    ReferenceId: "540",
    ReferenceKey: "PostingKey",
    ReferenceCode: "50",
    ReferenceText: "Credit entry",
    ReferenceProp1: "G",
    ReferenceProp2: "C",
    ReferenceProp3: "",
    ReferenceProp4: "TaxAmount,TaxCode,WBSElement,CostCenter,ProfitCenter",
    IsActive: "True",
  },
  {
    ReferenceId: "541",
    ReferenceKey: "PostingKey",
    ReferenceCode: "70",
    ReferenceText: "Debit asset",
    ReferenceProp1: "A",
    ReferenceProp2: "D",
    ReferenceProp3: "",
    ReferenceProp4: "TType,TaxCode,Order",
    IsActive: "True",
  },
  {
    ReferenceId: "542",
    ReferenceKey: "PostingKey",
    ReferenceCode: "75",
    ReferenceText: "Credit asset",
    ReferenceProp1: "A",
    ReferenceProp2: "C",
    ReferenceProp3: "",
    ReferenceProp4: "TType,TaxCode,Order",
    IsActive: "True",
  },
  {
    ReferenceId: "543",
    ReferenceKey: "PostingKey",
    ReferenceCode: "39",
    ReferenceText: "Special G/L credit",
    ReferenceProp1: "V",
    ReferenceProp2: "C",
    ReferenceProp3: "",
    ReferenceProp4:
      "TaxAmount,TaxCode,SGLInd,DueOn,PmtMethod,PmtMethodSupp,ProfitCenter,IndPayee",
    IsActive: "True",
  },
];
